import { DeepPartial, PartialsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_PARTIALS_CONFIG: DeepPartial<PartialsConfig> = {
  gridColumns: 4
};
